import merge from 'deepmerge';
import store from '../q-store';

import defaultLang from './langs/en';
// import caller from "../q-caller/caller";

let lang = defaultLang;
let locale = {};

function getLang() {
  let lang;
  try {
    lang = store.state.session.cultureName;
  } catch {
    lang = undefined
  }

  if (lang === undefined) {
    lang = "en";
  }

  return lang;
}

export const qt = (key) => {
  let current = locale;
  if (current === undefined || current === null || current === {})
    current = lang;

  key = getLang() + '.' + key;
  let caption = undefined;
  let property = undefined;
  const array = key.split('.');
  for (let i = 0, j = array.length; i < j; i++) {
    property = array[i];
    let value = current[property];
    if (i === j - 1) {
      caption = value;
      break;
    }
    if (!value) break;
    current = value;
  }
  if (caption !== undefined) {
    return caption;
  }

  return property;
  // AMIN
  // caller.delegate('gausaka', 'getBundle', {
  //   key: property
  // }).then((res) => {
  //   return res.result.caption;
  // }).catch(() => {
  //   return key;
  // });
};

export const use = (lang, l) => {
  let newLang = {};
  newLang[lang] = l;

  locale = merge(locale, newLang);
};

export const add = (lang, value) => {
  locale[lang] = merge(locale[lang], value);
};

export default {use, qt, add};


